module.exports = __webpack_public_path__ + "static/media/schedule.635e820f.png";